
















































/* eslint-disable @typescript-eslint/camelcase */
import { Component, Vue } from 'vue-property-decorator'
import * as messages from '@/services/messages'
import { Message } from '@/types/Messages'
import { User } from '@/types/Users'

@Component
export default class Conversation extends Vue {
  message = ''
  sendingMessage = false

  metaInfo(): any {
    return {
      title: this.conversation
        ? this.$options.filters?.groupNameList(
            this.conversation,
            this.me
          )
        : 'Conversation',
    }
  }

  async mounted() {
    // TODO: get the text input to focus
    // console.log(this.$refs.message) //.$el.focus();
    await messages.loadConversation(this.$store, parseInt(this.$route.params.conversationId))
  }

  get me() {
    return this.$store.getters.me
  }

  get conversation() {
    const conversation = this.$store.getters.conversation(
      this.$route.params.conversationId
    )
    return conversation
  }

  sentByMe(message: Message) {
    return message.sender_id == this.me.id
  }

  // Determine if the message info should be shown
  showInfo(messageIndex: number) {
    const current = this.conversation.messages[messageIndex]
    const next = this.conversation.messages[messageIndex + 1]

    if (next) {
      // The messages were sent by different users
      if (current.sender_id != next.sender_id) return true

      // The messages were sent more than a minute apart
      return (
        new Date(next.timestamp).getTime() -
          new Date(current.timestamp).getTime() >
        60 * 1000
      )
    }
    return true
  }

  // Check if the message was sent today
  isToday(timestamp: string) {
    const now = new Date()
    const then = new Date(timestamp)
    return !(
      now.getUTCDay() == then.getUTCDay() &&
      now.getUTCMonth() == then.getUTCMonth() &&
      now.getUTCFullYear() == then.getUTCFullYear()
    )
  }

  async sendMessage() {
    if (!this.message) return

    // Split the message into chunks of 500 characters
    const chunks = this.message.match(/.{1,500}/g)
    if (!chunks) return

    this.sendingMessage = true
    for (const chunk of chunks) {
      if (!chunk) continue
      
      await messages.sendMessage(
        this.$store,
        { body: chunk },
        parseInt(this.$route.params.conversationId)
      )
    }
    this.sendingMessage = false
    this.message = ''
  }

  // TODO: Move the participants data into `users` state module
  participant(participantId: number) {
    const participant = this.conversation.participants.find(
      (p: User) => p.id == participantId
    )
    return participant
  }
}
